import './App.css';
import Splash from './components/Splash/splash';
import PlayerMainScreen from './pages/PlayerMainScreen';
import TodayPrize from './pages/TodayPrize';
import PlayerWaitingScreen from './pages/PlayerWaitingScreen';
import ReviewPage from './pages/ReviewPage';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Challange from './pages/Challange';
import LeaderBoard from './pages/LeaderBoard';
import { useEffect, useState } from 'react';
function App() {

  // const screenWidth = window.innerWidth;

  const [isWideScreen, setIsWideScreen] = useState(window.innerWidth >= 1000);

  useEffect(() => {
    const handleResize = () => setIsWideScreen(window.innerWidth >= 1000);
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return (
    <>

      {/* <PlayerMainScreen/> */}
      {/* <PlayerWaitingScreen/> */}


      {window.innerWidth >= 1000? (
      
      <BrowserRouter>

      <Routes>
      
        <Route path="/sd" element={<ReviewPage />} />
        <Route path="/playerscreen" element={<PlayerMainScreen />} />
        <Route path="/playerwaiting" element={<PlayerWaitingScreen />} />
        <Route path="/" element={<Splash />} />
        <Route path="/today-prize" element={<TodayPrize />} />
        <Route path="/challange" element={<Challange />} />
      
      
      
        <Route path="/leaderboard" element={<LeaderBoard />} />
      
      </Routes>
      
      </BrowserRouter>

      ):
      (
        <div className="d-flex justify-content-center align-items-center" style={{width:"100%", height:"100vh", background:"radial-gradient(88.22% 88.22% at 50% 0%, rgba(11, 90, 98, 0.8) 0%, rgba(7, 67, 75, 0) 100%), #000B0C"}}>

<h1 className='text-light text-center' >This page does not support on this resolution (0 to 1000)</h1>

        </div>
      )
      }

     



 

    </>
  );
}

export default App;
